<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">

    <div class="mobile-header-bar">
      <div class="header-content">
        <img src="img/logo-v2.png" alt="Logo" class="mobile-logo">

        <button class="burger-menu" @click="toggleMobileMenu" :class="{ 'active': showMobileMenu }">
          <span class="bar"></span>
          <span class="bar"></span>
          <span class="bar"></span>
        </button>
      </div>

      <transition name="slide-down">
        <div v-if="showMobileMenu" class="mobile-dropdown">
          <router-link v-for="(link, index) in filteredLinks"
                       :key="index"
                       :to="link.path"
                       class="mobile-nav-link"
                       @click.native="showMobileMenu = false">
            <i :class="link.icon"></i>
            <span>{{ link.name }}</span>
          </router-link>
        </div>
      </transition>
    </div>

    <side-bar>
      <sidebar-link v-for="(link, index) in filteredLinks"
                    :key="index"
                    :to="link.path"
                    class="desktop-only-links"
                    @click.native="handleLinkClick($event, link)">
        <i :class="link.icon + ' fa-fw'"></i>
        <p>{{ link.name }}</p>
      </sidebar-link>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>

      <div class="page-content">

      <dashboard-content @click.native="toggleSidebar"></dashboard-content>
      </div>

      <content-footer v-if="isFooterVisible"></content-footer>
    </div>

  </div>
</template>

<script>
import TopNavbar from './TopNavbar.vue'
import ContentFooter from './ContentFooter.vue'
import DashboardContent from './Content.vue'
import { getMe } from "@/store/schedule";

export default {
  components: { TopNavbar, ContentFooter, DashboardContent },
  data() {
    return {
      userType: 'client',
      showMobileMenu: false
    }
  },
  mounted() {
    this.checkUserStatus();
  },
  computed: {
    // --- NEW LOGIC FOR FOOTER VISIBILITY ---
    isFooterVisible() {
      const path = this.$route.path;

      // 1. Show on exact Schedule page
      if (path === '/schedule') {
        return true;
      }

      // 2. Show on Study Groups Day page
      // Matches: /study-groups/ANYTHING/day
      const studyGroupRegex = /^\/study-groups\/[^/]+\/day$/;
      if (studyGroupRegex.test(path)) {
        return true;
      }

      // 3. Show on Tutor Schedule page
      // Matches: /tutor-schedule/37 (any ID)
      const tutorScheduleRegex = /^\/tutor-schedule\/\d+$/;
      if (tutorScheduleRegex.test(path)) {
        return true;
      }

      // Hide everywhere else
      return false;
    },
    filteredLinks() {
      const links = [];
      links.push({ name: 'Расписание', path: '/schedule', icon: 'bx bx-time' });

      if (this.userType === 'admin') {
        links.push(
          { name: 'Расписании', path: '/admin/manage-schedule', icon: 'bx bx-list-check' },
          { name: 'Группы', path: '/admin/create-group', icon: 'bx bx-group' },
          { name: 'Предметы', path: '/admin/create-subject', icon: 'bx bx-book' },
          { name: 'Семестр', path: '/admin/semesters', icon: 'bx bx-book' },
          { name: 'Преподаватели', path: '/admin/create-tutor', icon: 'bx bx-id-card' },
          { name: 'Пользователи', path: '/admin/create-user', icon: 'bx bx-user-plus' },
          { name: 'Выйти', path: '/logout', icon: 'bx bx-power-off', isLogout: true }
        );
      } else {
        links.push({ name: 'Вход', path: '/login', icon: 'bx bx-log-in' });
      }
      return links;
    }
  },
  methods: {
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;
    },
    async checkUserStatus() {
      const token = localStorage.getItem('token');
      if (!token) { this.userType = 'client'; return; }
      try {
        const userData = await getMe();
        this.userType = userData ? 'admin' : 'client';
      } catch (error) {
        localStorage.removeItem('token');
        this.userType = 'client';
      }
    },
    handleLinkClick(event, link) {
      if (link.isLogout) {
        if (event) event.preventDefault();
        localStorage.removeItem('token');
        this.userType = 'client';
        this.$router.replace('/login');
      }
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
}
</script>

<style lang="scss">
/* Reset to ensure full height */
html, body {
  height: 100%;
  margin: 0;
}

/* Flexbox Layout */
.main-panel {
  display: flex;
  flex-direction: column;
  position: relative;
  float: right;
  width: calc(100% - 260px);
  //background-color: #f4f3ef;
  transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);

  /* Force middle content to fill space */
  & > .content,
  & > div:nth-child(2) {
    flex: 1;
    width: 100%;
  }

  /* Ensure footer background is transparent to match panel */
  .footer, .page-footer {
    background-color: transparent !important;
  }
}
</style>

<style lang="scss" scoped>
/* --- MOBILE HEADER STYLES --- */
.mobile-header-bar {
  display: none; /* Hidden on desktop */
  position: fixed;
  top: 0;
  width: 100%;
  background: dimgrey;
  z-index: 2000;
  color: white;

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    height: 60px;
  }

  .mobile-logo { height: 35px; }
}

/* BURGER ICON STYLING */
.burger-menu {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 5px;
  .bar {
    display: block;
    width: 25px;
    height: 3px;
    background-color: white;
    transition: 0.3s;
  }
  &.active .bar:nth-child(1) { transform: translateY(8px) rotate(45deg); }
  &.active .bar:nth-child(2) { opacity: 0; }
  &.active .bar:nth-child(3) { transform: translateY(-8px) rotate(-45deg); }
}

/* DROPDOWN MENU */
.mobile-dropdown {
  background: dimgrey;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .mobile-nav-link {
    padding: 15px 25px;
    color: white;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 15px;
    border-bottom: 1px solid rgba(255,255,255,0.1);
    &:last-child { border: none; }
  }
}

/* TRANSITION ANIMATION */
.slide-down-enter-active, .slide-down-leave-active {
  transition: all 0.4s ease;
  max-height: 500px;
}
.slide-down-enter, .slide-down-leave-to {
  max-height: 0;
  opacity: 0;
}

/* RESPONSIVE TOGGLE */
@media (max-width: 991px) {
  .mobile-header-bar { display: block; }

  /* Reset Main Panel for Mobile */
  .main-panel {
    width: 100% !important;
    margin-left: 0 !important;
    float: none !important;
    margin-top: 60px; /* Space for fixed header */
  }
}


.page-content {
  flex: 1;        // faqat content cho‘ziladi
  width: 100%;
}


</style>
